<template>
  <div class="dashboard-profile">
    <div id="content">
      <div class="register">
        <div class="">
          <div class="inner">
            <div class="main">
              <sui-form autocomplete="off" class="ui form">
                <div class="list">
                  <h3 class="title">My Profile</h3>
                  <sui-form-field required>
                    <label>Name</label>
                    <div class="two-fields">
                      <sui-form-field>
                        <input
                          type="text"
                          name="shipping[first-name]"
                          placeholder="First Name"
                        />
                      </sui-form-field>
                      <sui-form-field>
                        <input
                          type="text"
                          name="shipping[last-name]"
                          placeholder="Last Name"
                        />
                      </sui-form-field>
                    </div>
                  </sui-form-field>
                  <sui-form-field required>
                    <label>Email</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter your email"
                    />
                  </sui-form-field>
                  <sui-form-field>
                    <label>LinkedIn URL</label>
                    <input
                      type="text"
                      name="linkedin"
                      placeholder="Please provide us your LinkedIn URL"
                    />
                  </sui-form-field>
                  <sui-form-field>
                    <label>LINE ID</label>
                    <input
                      type="text"
                      name="line"
                      placeholder="Please provide us your LINE ID"
                    />
                  </sui-form-field>
                  <sui-form-field>
                    <label>Phone No.</label>
                    <input
                      type="text"
                      name="phone"
                      placeholder="Enter your phone number"
                    />
                  </sui-form-field>
                  <sui-form-field required>
                    <label
                      >Which industry are you specialized in?
                      <span class="field-note"
                        >(Can select more than 1)</span
                      ></label
                    >
                    <ul class="checkbox-group">
                      <li class="item">
                        <input id="" type="checkbox" name="industry" />
                        <span class="item-text">Information Technology</span>
                      </li>
                      <li class="item">
                        <input id="" type="checkbox" name="industry" />
                        <span class="item-text">Telecommunications</span>
                      </li>
                      <li class="item">
                        <input id="" type="checkbox" name="industry" />
                        <span class="item-text">Web / Mobile / Gaming </span>
                      </li>
                      <li class="item">
                        <input id="" type="checkbox" name="industry" />
                        <span class="item-text">Food Service</span>
                      </li>
                    </ul>
                  </sui-form-field>
                  <sui-form-field required>
                    <label
                      >Do you want to receive an email once the selection status
                      is updated?</label
                    >
                    <div class="radio-checkbox">
                      <sui-form-fields inline>
                        <sui-form-field>
                          <sui-checkbox
                            v-model="value"
                            label="Yes"
                            radio
                            name="get-email"
                            value="1"
                          />
                        </sui-form-field>
                        <sui-form-field>
                          <sui-checkbox
                            v-model="value"
                            label="No"
                            radio
                            name="get-email"
                            value="2"
                          />
                        </sui-form-field>
                      </sui-form-fields>
                    </div>
                  </sui-form-field>
                  <sui-form-field required>
                    <label
                      >Do you want to receive our newsletter with job
                      updates?</label
                    >
                    <div class="radio-checkbox">
                      <sui-form-fields inline>
                        <sui-form-field>
                          <sui-checkbox
                            v-model="value"
                            label="Yes"
                            radio
                            name="news"
                            value="1"
                          />
                        </sui-form-field>
                        <sui-form-field>
                          <sui-checkbox
                            v-model="value"
                            label="No"
                            radio
                            name="news"
                            value="2"
                          />
                        </sui-form-field>
                      </sui-form-fields>
                    </div>
                  </sui-form-field>
                  <h3 class="title">Password Change</h3>
                  <sui-form-field>
                    <label>New Password</label>
                    <input
                      type="password"
                      name="new-password"
                      placeholder="Leave blank if you don’t want to change it"
                    />
                  </sui-form-field>
                  <sui-form-field>
                    <input
                      type="password"
                      name="confirm-password"
                      placeholder="Confirm your new password"
                    />
                  </sui-form-field>
                  <sui-form-field>
                    <label>Current Password</label>
                    <input
                      type="password"
                      name="current-password"
                      placeholder="We need your current password to confirm your change"
                    />
                  </sui-form-field>
                  <h3 class="title">Account Cancelation</h3>
                  <a class="link cancel" href="/"
                    ><i class="las la-trash-alt"></i>Cancel my account</a
                  >
                  <div class="submit-button">
                    <button class="btn btn-blue" type="submit">Update</button>
                  </div>
                </div>
              </sui-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DashboardProfile",
};
</script>
<style lang="scss">
@import "@/assets/stylesheets/application";
@import "@/assets/stylesheets/register";
.dashboard-profile {
  .register {
    width: 800px;
    h3.title {
      color: #1a1a1a;
      font-size: 1.25em;
      font-weight: 700;
      margin: 1.5rem 0;

      &:first-of-type {
        margin-top: 0;
      }
    }
    .ui.form {
      width: 100%;
      .radio-checkbox {
        .field {
          margin-right: 2rem;
        }
        .checkbox {
          label {
            font-weight: 400;
          }
          label::before {
            border: 1px solid #1a1a1a;
            border-radius: 500rem;
            content: "";
            height: 20px;
            left: 0;
            top: -2px;
            transform: none;
            width: 20px;
          }
          label::after {
            height: 20px;
            top: -2px;
            width: 20px;
          }
          input:checked ~ label::after {
            background: #3742fa;
          }
          input:checked ~ label::before {
            border: 1px solid #3742fa;
          }
        }
      }
    }
    .link {
      align-items: center;
      color: #3742fa;
      display: flex;
      flex-direction: row;
      font-size: 1em;
      font-weight: 700;
      transition: all 0.4s ease-in-out;
      &:hover,
      &:focus {
        /* stylelint-disable-next-line declaration-no-important */
        box-shadow: none !important;
        filter: contrast(150%);
        text-decoration: none;
      }

      i {
        font-size: 24px;
        margin-right: 10px;
      }
    }
    .submit-button {
      .btn {
        padding: 0.75rem 2rem;
        /* stylelint-disable-next-line declaration-no-important */
        width: auto !important;
      }
    }
  }
}
@media only screen and (max-width: 991px) {
  .dashboard-profile {
    .register {
      width: 100%;
      h3.title {
        font-size: 1.15em;
        margin: 1rem 0;
      }
    }
  }
}
</style>
